import {useQuery} from '@tanstack/react-query';
import {getUPSRegistrationAccounts} from 'App/api/registration/typed';
import {useUserMe} from 'App/data-hooks';
import {COMPANY_INTEGRATION_UPS} from 'App/data-hooks/queryKeys';

export const useGetUpsAccountsQuery = () => {
  const userQuery = useUserMe();
  const companyId = userQuery?.data?.company?.id;

  const upsQuery = useQuery(
    [COMPANY_INTEGRATION_UPS],
    async () => {
      const response = await getUPSRegistrationAccounts({});
      return response.data;
    },
    {
      onError: (error) => {
        console.error(error);
      }
    }
  );

  const isUpsAuthenticated = upsQuery?.data?.results?.find((result) => result.company === companyId);
  const isUpsEnabled = userQuery?.data?.company?.feature_flags?.ups_enabled;

  return {
    isUpsAuthenticated,
    upsQuery,
    isUpsEnabled
  };
};
